<mat-form-field class="price-list-container">
    <mat-label id="price-list-autocomplete-label">
        {{ (componentListSelected ? 'task.listPriceListOrInventory' : 'task.unit.unitListPriceList') | blah }}
    </mat-label>
    <input type="text"
        matInput
        id="price-list-select"
        [formControl]="priceListControl"
        [matAutocomplete]="auto"
        title="{{selectedListAttachment?.Name ?? ''}}">
    <mat-icon class="arrow" matSuffix>arrow_drop_down</mat-icon>
    <mat-autocomplete #auto="matAutocomplete"
        [panelWidth]="'null'"
        [displayWith]="displayFn"
        (optionSelected)="optionSelected($event)"
        (closed)="onClosed()">
        <mat-option [value]="null"
            id="{{'price-list-select-option-default'}}"
            title="{{ 'default.choose' | blah }}...">{{ 'default.choose' | blah }}...
        </mat-option>
        <mat-optgroup [label]="'task.unit.priceLists' | blah">
            <mat-option *ngFor="let pricelist of filteredPriceLists | async; let i=index"
                [value]="pricelist"
                id="{{'price-list-select-option-'+i}}"
                title="{{pricelist.Name}}">
                {{pricelist.Name}}
            </mat-option>
        </mat-optgroup>
        <mat-optgroup *ngIf="componentListSelected && inventoryProductLicense"
            [label]="'task.unit.inventories' | blah">
            <mat-option *ngFor="let inventory of filteredInventories | async; let i=index"
                [value]="inventory"
                id="{{'inventory-select-option-'+i}}"
                title="{{inventory.Name}}">
                {{inventory.Name}}
            </mat-option>
        </mat-optgroup>
    </mat-autocomplete>
</mat-form-field>